const actions = {
    PRODUCT_GROUP_CREATE_REQUEST: 'PRODUCT_GROUP_CREATE_REQUEST',
    PRODUCT_GROUP_CREATE_SUCCESS: 'PRODUCT_GROUP_CREATE_SUCCESS',
    PRODUCT_GROUP_CREATE_ERROR: 'PRODUCT_GROUP_CREATE_ERROR',
    PRODUCT_GROUP_READ_LIST_REQUEST: 'PRODUCT_GROUP_READ_LIST_REQUEST',
    PRODUCT_GROUP_READ_LIST_SUCCESS: 'PRODUCT_GROUP_READ_LIST_SUCCESS',
    PRODUCT_GROUP_READ_LIST_ERROR: 'PRODUCT_GROUP_READ_LIST_ERROR',
    PRODUCT_GROUP_READ_REQUEST: 'PRODUCT_GROUP_READ_REQUEST',
    PRODUCT_GROUP_READ_SUCCESS: 'PRODUCT_GROUP_READ_SUCCESS',
    PRODUCT_GROUP_READ_ERROR: 'PRODUCT_GROUP_READ_ERROR',
    PRODUCT_GROUP_UPDATE_REQUEST: 'PRODUCT_GROUP_UPDATE_REQUEST',
    PRODUCT_GROUP_UPDATE_SUCCESS: 'PRODUCT_GROUP_UPDATE_SUCCESS',
    PRODUCT_GROUP_UPDATE_ERROR: 'PRODUCT_GROUP_UPDATE_ERROR',
    PRODUCT_GROUP_DELETE_REQUEST: 'PRODUCT_GROUP_DELETE_REQUEST',
    PRODUCT_GROUP_DELETE_SUCCESS: 'PRODUCT_GROUP_DELETE_SUCCESS',
    PRODUCT_GROUP_DELETE_ERROR: 'PRODUCT_GROUP_DELETE_ERROR',

    PRODUCT_GROUP_INIT: 'PRODUCT_GROUP_INIT',
    PRODUCT_GROUP_RESET: 'PRODUCT_GROUP_RESET',

    PRODUCT_GROUP_SET_PRODUCT_IDS: 'PRODUCT_GROUP_SET_PRODUCT_IDS',
    PRODUCT_GROUP_SET_ALL_PRODUCT_IDS: 'PRODUCT_GROUP_SET_ALL_PRODUCT_IDS',

    createGroup: request => ({
        type: actions.PRODUCT_GROUP_CREATE_REQUEST,
        request,
    }),
    readGroupList: () => ({
        type: actions.PRODUCT_GROUP_READ_LIST_REQUEST,
    }),
    readGroup: id => ({
        type: actions.PRODUCT_GROUP_READ_REQUEST,
        id,
    }),
    updateGroup: (id, request) => ({
        type: actions.PRODUCT_GROUP_UPDATE_REQUEST,
        id,
        request,
    }),
    deleteGroup: id => ({
        type: actions.PRODUCT_GROUP_DELETE_REQUEST,
        id,
    }),
    initGroup: group => ({
        type: actions.PRODUCT_GROUP_INIT,
        group,
    }),
    setProductIds: selectedProductIds => ({
        type: actions.PRODUCT_GROUP_SET_PRODUCT_IDS,
        selectedProductIds,
    }),
    setAllProductIds: allProductIds => ({
        type: actions.PRODUCT_GROUP_SET_ALL_PRODUCT_IDS,
        allProductIds,
    }),
    resetState: () => ({
        type: actions.PRODUCT_GROUP_RESET,
    }),
};
export default actions;
